export default defineNuxtRouteMiddleware((to) => {
    // const isDisabledEnv = import.meta.env.VITE_BUILD_NAME === 'production' || import.meta.env.VITE_BUILD_NAME === 'xla';
    // const disabledExact = ['/drops'];
    // const disabledPrefix = ['/drops/'];
    //
    // if (
    //     isDisabledEnv
    //     && (disabledExact.includes(to.path) || disabledPrefix.some(prefix => to.path.startsWith(prefix)))
    // ) {
    //     return navigateTo('/');
    // }
});
